jQuery(document).ready(function ($) {
  console.log('Slider');
  var url = window.location.pathname;
  if (url.indexOf('/collections/') !== -1) {
    $('ul.site-nav.site-navigation.medium-down--hide>li:last-child').css("background-color","#d15334");
  }
  if (url.indexOf('/pages/') !== -1 || url.indexOf('/blogs/') !== -1) {
    $('ul.site-nav.site-navigation.medium-down--hide>li:first-child').css("background-color","#d15334");
  }
  $('.filter-button').click(function (e) {
    $(this).next().toggle();
  });
  
  $('.testimonials_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    centerMode: true,
    centerPadding: '10%',
    focusOnSelect: true,

    responsive: [
      {
        breakpoint: 1440,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: false,
          centerPadding: '20px',
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: false,
          centerPadding: '20px',
          slidesToShow: 1,
        },
      },
    ],
  });
  $('.meet_your_match').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(
    'button.slick-prev.slick-arrow'
  ).html(`<svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52">
  <g id="Group_48" data-name="Group 48" transform="translate(-199 -2372.904)">
    <ellipse id="Ellipse_9" data-name="Ellipse 9" cx="25" cy="25" rx="25" ry="25" transform="translate(200 2373.904)" fill="none" stroke="#14433d" stroke-width="2"/>
    <path id="Path_18" data-name="Path 18" d="M233.387,2422.846,222.638,2412.1l10.749-10.749" transform="translate(-9.1 -13.193)" fill="none" stroke="#20372e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <line id="Line_4" data-name="Line 4" x2="25" transform="translate(213.6 2398.904)" fill="none" stroke="#20372e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </g>
</svg>

  `);
  $(
    'button.slick-next.slick-arrow'
  ).html(`<svg xmlns="http://www.w3.org/2000/svg" width="52.22" height="52.22" viewBox="0 0 52.22 52.22">
  <g id="Group_49" data-name="Group 49" transform="translate(-1642.505 -2372.794)">
    <ellipse id="Ellipse_10" data-name="Ellipse 10" cx="25" cy="25" rx="25" ry="25" transform="translate(1643.615 2373.904)" fill="none" stroke="#14433d" stroke-width="2.22"/>
    <path id="Path_19" data-name="Path 19" d="M1686.613,2401.348l10.749,10.749-10.749,10.749" transform="translate(-17.285 -13.193)" fill="none" stroke="#20372e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.22"/>
    <line id="Line_5" data-name="Line 5" x1="25" transform="translate(1653.436 2398.904)" fill="none" stroke="#20372e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.22"/>
  </g>
</svg>
`);

  $('div#shopify-section-template--14441649897550__1656063879039c17ef #play').click(function () {
    $('div#shopify-section-template--14441649897550__1649833206168c7f1c').show();
  });
  
    $('div#shopify-section-template--14441649897550__1656063879039c17ef #play').click(function () {
    $('div#shopify-section-template--14441649897550__1649833206168c7f1c').show();
  });
  $('div#shopify-section-template--14441649897550__1649833206168c7f1c').click((e) => {
    e.stopPropagation();
    $('div#shopify-section-template--14441649897550__1649833206168c7f1c').hide();
  });
  
  

  $('#play').click(function (e) {
    e.preventDefault();
    $('.modal_popup').show();
    $('body').addClass('modal_open');
  });

  $('.modal_popup .close-modal').click(function (e) {
    $('body').removeClass('modal_open');
    $('.modal_popup').hide();
  });
  
    $('div#shopify-section-template--14441650257998__16494078487827d986 img').click(function () {
    $('div#shopify-section-template--14441650257998__16554112948b1bfe2b').show();
  });
 
    $('div#shopify-section-template--14441650257998__16554112948b1bfe2b').click((e) => {
    e.stopPropagation();
    $('div#shopify-section-template--14441650257998__16554112948b1bfe2b').hide();
  });
  

  $(".min-read").each(function () {
     const rand = Math.floor(Math.random() * 10);
     const text = `${rand} min read`
     $(this).text(text)
  })
  
  
});
